// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"copy_copyButton__20AWz","copiedTooltipFloating":"copy_copiedTooltipFloating__2qZwt","active":"copy_active__I_IL3"};